<template>
  <div :class="['box', { 'box-empty': !alertsStore.alerts.length && !modalEventsStore.modals.length }]">
    <transition-group name="fade"
                      tag="div"
                      class="alerts-wrapper"
    >
      <Toast v-for="alert in alertsStore.alerts"
             :key="alert.id"
             :description="alert.description"
             :text-title="alert.title"
             :type="typeClass(alert.status)"
             class="item"
             :timer="alert.timer"
             @close-toast="alertsStore.remove(alert.id)"
      />
    </transition-group>

    <transition-group name="fade"
                      tag="div"
    >

      <EventModal v-for="(modal, index) in modalEventsStore.modals"
                  :key="`${modal.type}_${index}`"
                  :data="modal"
                  @close-modal="modalEventsStore.remove(modal.id)"
      />
    </transition-group>
  </div>
</template>

<script lang="ts" setup>
import type { TypeToast } from '@/components/widgets/modals/Toast/Toast.types';
import Toast from '@/components/widgets/modals/Toast/Toast.vue';
import type { AlertStatus } from '@/stores/alerts/alerts.types';
import { useAlertsStore } from '@/stores/alerts/useAlertsStore';
import { useEventModalsStore } from '@/stores/eventModals/useEventModalsStore';

const alertsStore = useAlertsStore();

const modalEventsStore = useEventModalsStore();

const typeClassMapping: Record<number, TypeToast> = {
    0: 'type.info', // Неопределенный статус
    1: 'type.info', // 1xx Информационные
    2: 'type.success', // 2xx Успешные
    4: 'type.error', // 4xx Клиентские ошибки
    5: 'type.error' // 5xx Серверные ошибки
};

const typeClass = (status: AlertStatus) => {
    if (typeof status === 'number') {
        const category = Math.floor(status / 100);
        return typeClassMapping[category] ?? 'type.info';
    }
    else {
        return status;
    }
};
</script>

<style lang="scss" scoped>
.box {
  position: fixed;
  z-index: 10000;
  top: 10%;
  right: 0;
  left: 0;
  width: fit-content;
  height: 100%;
  margin: auto;
  padding: 10px 10px 0 0;
  transition: all 250ms ease;
  //pointer-events: none;
}

.alerts-wrapper{
  position: sticky;
  z-index: 10000;
}

.box-empty {
  pointer-events: none;
  user-select: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
